import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Select } from 'antd'
import moment from 'moment'

import './index.scss';

import { IconMessage, IconPhone, IconEmail, IconEdit, IconClose } from '../../../../data/assets/icons';
import { formatPrice, formatDate, showMessage } from '../../../../data/config/utils';
import { PROFILE_ITEM_TYPE, CURRENCY, BOT_EVENT_SOURCE, ROUTE_PATH } from '../../../../data/config/constants';
import { updateTagsInConversations } from '../../../../data/redux/page_details/actions'
import { getAllTags } from '../../../../data/redux/member_details/actions'
import { makeGetTagsByGroup, getIsEmptyTagList } from '../../../../data/redux/member_details/selectors'

import InlineItem from '../../../../components/inlineitem';
import AvatarCard from '../../../../components/avatarcard';
import InputItem from '../../../../components/form/inputitem';
import TextareaItem from '../../../../components/form/textareaitem';
import ModalFooter from '../../../../components/modalfooter';
import ErrorBoundary from '../../../../components/errorboundary';

class ProfileCard extends React.PureComponent {
  state = {
    note_editing: false,
    agent_note_form: [],
    tag_editing: false,
    updated_tag_ids: []
  };

  componentDidMount() {
    const { isEmptyTagList, actions } = this.props
    if (isEmptyTagList)
      actions.getAllTags()
  }

  onClickAvatar = () => {
    const { profile_details, history } = this.props;
    if (profile_details.userUrlInfo && profile_details.userUrlInfo.id && profile_details.userUrlInfo.type) {
      const path = `${ROUTE_PATH.USERS}/${profile_details.userUrlInfo.id}&type=${profile_details.userUrlInfo.type}`;
      history.push(path);
    }
  };

  startTagEditing = () => {
    const { profile_details } = this.props
    const tag_ids = []
    profile_details.selectedTags.forEach(tag => {
      if (tag._id)
        tag_ids.push(tag._id)
    })
    this.setState({
      tag_editing: true,
      updated_tag_ids: tag_ids
    })
  }

  onChangeUpdatedTags = updated_tag_ids => {
    this.setState({ updated_tag_ids })
  }

  cancelTagEditing = () => {
    this.setState({
      tag_editing: false,
      updated_tag_ids: []
    });
  }

  onClickUpdateTag = () => {
    const { updated_tag_ids } = this.state
    const { actions, profile_details, tagList } = this.props;
    if (profile_details.sessionId) {
      const payload = {
        psid: profile_details.psid,
        sessionId: profile_details.sessionId,
        selectedTags: tagList.filter(tag => updated_tag_ids.includes(tag._id))
      }
      actions.updateTagsInConversations(payload, this.cancelTagEditing)
    } else
      showMessage('warning', 'sessionId is missing')
  }

  startCustomAgentNoteEditing = () => {
    const { profile_details } = this.props;
    this.setState({
      note_editing: true,
      agent_note_form: profile_details.customAgentNotes.form
    });
  };

  cancelCustomAgentNoteEditing = () => {
    this.setState({
      note_editing: false,
      agent_note_form: []
    });
  };

  handleFormInputChange = (index, event) => {
    const { agent_note_form } = this.state;
    this.setState({
      agent_note_form: [
        ...agent_note_form.slice(0, index),
        {
          ...agent_note_form[index],
          value: event.target.value
        },
        ...agent_note_form.slice(index + 1)
      ]
    });
  };

  onClickSubmitAgentNoteForm = () => {
    const { agent_note_form } = this.state;
    const { submitCustumAgentNoteForm } = this.props;
    submitCustumAgentNoteForm(agent_note_form, this.cancelCustomAgentNoteEditing)
  };

  filterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

  renderCustomAgentNoteForm = () => {
    const { profile_details } = this.props;
    const { note_editing, agent_note_form } = this.state;
    if (note_editing) {
      return (
        <React.Fragment>
          {
            agent_note_form.map((item, index) => {
              switch (item.input_type) {
                case "input":
                  return (<InputItem key={index} {...item} onChange={this.handleFormInputChange.bind(this, index)} />);

                case "textarea":
                  return (<TextareaItem key={index} {...item} onChange={this.handleFormInputChange.bind(this, index)} />);

                default:
                  return null;
              }
            })
          }
          <ModalFooter size="small" button_ok_text="submit" handleCancelClick={this.cancelCustomAgentNoteEditing} handleOkClick={this.onClickSubmitAgentNoteForm} />
        </React.Fragment>
      );
    }
    return (
      profile_details.customAgentNotes.form.map((item, index) => {
        return (
          <InlineItem key={index} title={item.title} info={item.value} size="small" />
        );
      })
    );
  }

  render() {
    const { profile_details, hide_avatar, submitCustumAgentNoteForm, tagList } = this.props;
    const { note_editing, tag_editing, updated_tag_ids } = this.state;
    return (
      <div className="ori-flex-column ori-full-width ori-pad-10 oriProfileCardContainer">
        <ErrorBoundary>
          <AvatarCard
            image_url={profile_details.imageUrl}
            title={profile_details.udf1}
            sub_title={profile_details.udf2}
            sub_title2={profile_details.udf3}
            mobile={profile_details.rmn}
            email={profile_details.email}
            hide_avatar={hide_avatar}
            onClickAvatar={this.onClickAvatar}
          />
        </ErrorBoundary>
        {
          tag_editing && tagList && tagList.length > 0 && profile_details.selectedTags &&
          <div className="ori-animated ori-fade-in ori-pad-8 ori-border-radius-4 ori-bg-default ori-tb-mrgn-5">
            <p className="ori-font-bold ori-b-mrgn-5">UPDATE TAGS</p>
            <div className="ori-pad-5 ori-border-radius-4 ori-bg-white">
              <Select
                mode='multiple'
                className="ori-full-width ori-b-mrgn-5"
                placeholder='Select tags'
                value={updated_tag_ids}
                onChange={this.onChangeUpdatedTags}
                filterOption={this.filterOption}
                dropdownRender={menu => (
                  <React.Fragment>
                    {menu}
                    <ModalFooter
                      size="small"
                      button_ok_text="update"
                      handleCancelClick={this.cancelTagEditing}
                      handleOkClick={this.onClickUpdateTag}
                    />
                  </React.Fragment>
                )}
              >
                {
                  tagList.map(tag => {
                    return (
                      <Select.Option
                        key={tag._id}
                        value={tag._id}
                      >
                        {tag.name}
                      </Select.Option>
                    )
                  })
                }
              </Select>
              <ModalFooter
                size="small"
                button_ok_text="update"
                handleCancelClick={this.cancelTagEditing}
                handleOkClick={this.onClickUpdateTag}
              />
            </div>
          </div>
        }
        {
          !tag_editing && profile_details.selectedTags &&
          <div className="ori-relative ori-t-mrgn-5 ori-tb-pad-5 ori-flex-row ori-flex-jc ori-flex-wrap">
            {
              tagList && tagList.length > 0 && profile_details.selectedTags.length !== 0 &&
              <IconEdit
                className="ori-absolute ori-font-light-hover-default ori-align-right ori-align-bottom-full"
                onClick={this.startTagEditing}
              />
            }
            {
              tagList && tagList.length > 0 && profile_details.selectedTags.length === 0 &&
              <p className="ori-font-light-hover-default" onClick={this.startTagEditing}>Add Tags</p>
            }
            {
              profile_details.selectedTags.map(tag => (
                <div
                  key={tag._id}
                  className="ori-bg-primary ori-font-white ori-border-primary ori-border-radius-3 ori-lr-pad-5 ori-r-mrgn-5 ori-b-mrgn-5 ori-font-xs"
                >
                  {tag.name}
                </div>
              ))
            }
          </div>
        }
        {
          profile_details.sections && profile_details.sections.length > 0 &&
          profile_details.sections.map((section, index) => {
            if (section && section.data && section.data.length > 0) {
              return (
                <ErrorBoundary key={index}>
                  <div className="ori-animated ori-fade-in ori-pad-8 ori-border-radius-4 ori-bg-default ori-tb-mrgn-5">
                    {
                      section.sectionTitle &&
                      <p className="ori-font-bold ori-uppercase ori-b-mrgn-5">{section.sectionTitle}</p>
                    }
                    <div className="ori-pad-5 ori-font-light ori-border-radius-4 ori-bg-white">
                      {
                        section.data.map((item, index) => {
                          if (item && item.type === PROFILE_ITEM_TYPE.CURRENCY) {
                            item = { ...item, value: formatPrice(item.value, CURRENCY.RUPEES) };
                          } else if (item && item.type === PROFILE_ITEM_TYPE.DATE) {
                            item = { ...item, value: formatDate(item.value, { year: "numeric", month: "short", day: "numeric" }) };
                          } else if (item && item.type === PROFILE_ITEM_TYPE.DATE_TIME) {
                            item = { ...item, value: moment(item.value).format("DD-MM-YYYY, hh:mm A") };
                          }
                          if (item && item.value) {
                            return (
                              <InlineItem key={index} title={item.subTitle} info={item.value} size="small" url={item.type && item.type === PROFILE_ITEM_TYPE.URL} />
                            );
                          } else {
                            return null;
                          }
                        })
                      }
                    </div>
                  </div>
                </ErrorBoundary>
              );
            } else {
              return null;
            }
          })
        }
        {
          profile_details.customAgentNotes &&
          <div className="ori-relative ori-animated ori-fade-in ori-pad-8 ori-border-radius-4 ori-bg-default ori-tb-mrgn-5">
            {
              submitCustumAgentNoteForm &&
              <div className="ori-absolute ori-align-right ori-align-top ori-pad-5 ori-font-light-hover-primary" onClick={note_editing ? this.cancelCustomAgentNoteEditing : this.startCustomAgentNoteEditing}>
                {note_editing ? <IconClose /> : <IconEdit />}
              </div>
            }
            <p className="ori-font-bold ori-uppercase ori-b-mrgn-5">{profile_details.customAgentNotes.title}</p>
            <div className="ori-pad-5 ori-bg-white">
              {this.renderCustomAgentNoteForm()}
            </div>
          </div>
        }
        {
          profile_details.botEvents && profile_details.botEvents.length > 0 &&
          <div className="ori-animated ori-fade-in ori-pad-8 ori-border-radius-4 ori-bg-default ori-tb-mrgn-5">
            <p className="ori-font-bold ori-uppercase ori-b-mrgn-5">Bot Events</p>
            <div className="ori-pad-5 ori-bg-white">
              {
                profile_details.botEvents.map((bot_event, index) => {
                  return (
                    <ErrorBoundary key={index}>
                      <div className="ori-border-radius-4 ori-font-light ori-flex-row  ori-font-xs botEventItem">
                        <div className="ori-full-flex ori-word-break-all">
                          {
                            bot_event.source && bot_event.source === BOT_EVENT_SOURCE.CHAT &&
                            <IconMessage size={12} className="ori-r-mrgn-5 ori-font-primary" />
                          }
                          {
                            bot_event.source && bot_event.source === BOT_EVENT_SOURCE.CALL &&
                            <IconPhone size={12} className="ori-r-mrgn-5 ori-font-info" />
                          }
                          {
                            bot_event.source && bot_event.source === BOT_EVENT_SOURCE.EMAIL &&
                            <IconEmail size={12} className="ori-r-mrgn-5 ori-font-warning" />
                          }
                          {bot_event.tag}
                        </div>
                        <div className="ori-l-pad-5 ori-r-pad-10">{moment(bot_event.createdAt).format("hh:mm A")}</div>
                        <div>
                          <div className={classNames("ori-lr-pad-5  ori-border-radius-4 ori-uppercase ori-font-xxs ori-flex-column ori-flex-jc", { "ori-font-green ori-bg-green-light": bot_event.tagType.toLowerCase() === "success", "ori-font-primary ori-bg-primary-light": bot_event.tagType.toLowerCase() !== "success", })}>{bot_event.tagType}</div>
                        </div>
                      </div>
                    </ErrorBoundary>
                  );
                })
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

const makeMapStateToProps = () => {
  const getTagsByGroup = makeGetTagsByGroup()
  const mapStateToProps = (state, props) => {
    return {
      tagList: getTagsByGroup(state, props),
      isEmptyTagList: getIsEmptyTagList(state)
    }
  }
  return mapStateToProps;
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updateTagsInConversations,
        getAllTags
      },
      dispatch
    )
  };
};

ProfileCard.propTypes = {
  actions: PropTypes.object,
  tagList: PropTypes.array,
  isEmptyTagList: PropTypes.bool,
  profile_details: PropTypes.object.isRequired,
  history: PropTypes.object,
  hide_avatar: PropTypes.bool,
  submitCustumAgentNoteForm: PropTypes.func,
};

export default withRouter(connect(makeMapStateToProps, mapDispatchToProps)(ProfileCard))


// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/profilecard/index.js